import { render, staticRenderFns } from "./SelectMerchant.vue?vue&type=template&id=0240faa2"
import script from "./SelectMerchant.vue?vue&type=script&lang=js"
export * from "./SelectMerchant.vue?vue&type=script&lang=js"
import style0 from "./SelectMerchant.vue?vue&type=style&index=0&id=0240faa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports